const envSettings = window;
export class Config {
  static REACT_APP_API_URL = envSettings.REACT_APP_API_URL;
}